import { Flex } from "@chakra-ui/react";
import React from "react";

type PropTypes = {
  children: React.ReactNode;
};

const BottomAction = ({ children }: PropTypes) => (
  <Flex
    background="white"
    direction="column"
    alignItems="stretch"
    borderRadius={{ md: "lg" }}
    borderTopWidth="2px"
    borderWidth={{ md: "2px" }}
    p={{ base: 4, md: 8 }}
    boxShadow={{ base: "0px 2px 16px rgba(0, 0, 0, 0.1)", md: "none" }}
    position={{ base: "fixed", md: "initial" }}
    bottom={0}
    left={0}
    right={0}
    mb={{ md: 8 }}
    mt={8}
    zIndex={3}
  >
    {children}
  </Flex>
);

export default BottomAction;
